import React, { useMemo } from "react";
import Image from "next/legacy/image";
import cx from "classnames";
import { IWalletComponent } from "@novel/shared/components/ConnectWalletComponent/types";
import { getTorusInstance } from "@novel/shared/utils/wallets/walletLibInstances";
import { AuthWallet } from "@novel/shared/utils/wallets/AuthWallet";
import { useAsyncCallback } from "@novel/shared/utils/useAsyncCallback";
import { TorusWalletCircleIcon } from "@novel/shared/icons";
import Torus from "@novel/shared/icons/torus.svg";
export function TorusWalletComponent({
  onConnectWallet,
  isInGate,
  AuthWalletClass = AuthWallet
}: IWalletComponent): JSX.Element {
  // init on mount
  const torusInitializePromise = useMemo(() => getTorusInstance(), []);
  const connectTorus = useAsyncCallback(async () => {
    await torusInitializePromise;
    await new AuthWalletClass("torus").ensureWalletAppInstalled(async wallet => onConnectWallet(await wallet.authenticate()));
  }, [onConnectWallet]);
  return <div className={cx("connect-wallet-button", isInGate && "connect-wallet-button-in-gate")} onClick={connectTorus}>
            {isInGate ? <TorusWalletCircleIcon height="50px" width="50px" style={{
      height: "50px",
      width: "50px"
    }} /> : <Image alt="torus wallet" src={Torus} layout="fixed" />}
            <div className={isInGate ? "connect-wallet-name-description-updated" : "connect-wallet-name-description"}>
                <span className={isInGate ? "Connect-title-field-updated" : "Connect-title-field"}>
                    Torus
                </span>
            </div>
        </div>;
}